"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Proxy = void 0;
exports.setAlertFunctions = setAlertFunctions;
/* eslint-disable no-console */
const watch_1 = require("./watch");
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const alert_1 = __importStar(require("./client/alert"));
// export a setter for the alert function so we can selectively exclude the
// alert we use on the server from any client bundles
let _alertFunction = alert_1.default;
let _alertOnErrorFunction = alert_1.alertOnError;
function setAlertFunctions(newAlertFn, newAlertOnErrorFn) {
    _alertFunction = newAlertFn || _alertFunction;
    _alertOnErrorFunction = newAlertOnErrorFn || _alertOnErrorFunction;
}
class Proxy {
    error;
    warn;
    info;
    log;
    wrappedObject;
    watchFilter;
    usedChannels = [];
    constructor(wrappedObject, watchFilter) {
        this.wrappedObject = wrappedObject;
        this.watchFilter = watchFilter;
        this.log = this.wrap('log');
        this.info = this.wrap('info');
        this.warn = this.wrap('warn');
        this.error = this.wrap('error');
    }
    trace = (name, message, ...params) => {
        if (this.watchFilter(name)) {
            this.log(name, message, ...params);
            this.wrappedObject.trace();
        }
    };
    list = (match) => {
        let channels = this.usedChannels.slice();
        if (match) {
            channels = channels.filter((name) => (0, watch_1.matchChannel)(name, match));
        }
        return channels;
    };
    alert = (name, message, tags, data) => {
        this.error(name, message, tags, data);
        if (!(0, isPlainObject_1.default)(data)) {
            console.warn('[ddt] alert data is not a plain object', data);
            return;
        }
        if (_alertFunction) {
            return _alertFunction(name, message, tags, data);
        }
    };
    alertOnError = (error, name, message, tags, data = {}) => {
        this.warn(name, message, tags, data, error);
        if (_alertOnErrorFunction) {
            return _alertOnErrorFunction(error, name, message, tags, data);
        }
    };
    createLogger = (channel) => {
        const channelCurry = (callback) => {
            return (message, ...params) => {
                params.unshift(channel, message);
                return callback.apply(this, params);
            };
        };
        return {
            log: channelCurry(this.log),
            info: channelCurry(this.info),
            warn: channelCurry(this.warn),
            error: channelCurry(this.error),
            trace: channelCurry(this.trace),
        };
    };
    wrap(type) {
        if (!(type in this.wrappedObject)) {
            this.wrappedObject.warn('[ddt] cannot proxy this method, it is not defined in console', type);
        }
        const proxied = this.wrappedObject[type];
        return (name, message, ...params) => {
            if (this.usedChannels.indexOf(name) === -1) {
                this.usedChannels.push(name);
            }
            if (!this.watchFilter(name)) {
                return;
            }
            // reformat the message to include the package name
            params.unshift(`[${name}] ${message}`);
            return proxied.apply(this.wrappedObject, params);
        };
    }
}
exports.Proxy = Proxy;
//# sourceMappingURL=proxy.js.map